import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FeatureCard({
    title,
    description,
    variant = "dark",
    openInfo,
    image
}) {
    const isDark = variant === "dark";
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <Box
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={openInfo}
            sx={{
                width: "100%",
                maxWidth: 580,
                minWidth:400,
                aspectRatio: "4 / 3",
                borderRadius: "22px",
                p: "10px",
                display: "flex",
                flexDirection: "column",
                bgcolor: isDark ? "#20BC71" : "#fff",
                color: "#000",
                border: isDark ? "1px solid transparent" : "1px solid #1A1A1A",
                boxShadow: isDark ? "none" : "0 2px 10px rgba(0,0,0,0.06)",
                transition: "all 260ms ease",
                "&:hover": {
                    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    bgcolor: "#20BC71",
                    border: "1px solid transparent",
                },
                cursor: "pointer",
                overflow: "hidden",
            }}
        >
            {/* Imagen */}
            <Box
                sx={{
                    width: "100%",
                    height: "48%",
                    borderRadius: "14px",
                    backgroundImage: image ? `url(${image})` : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    flexShrink: 0,
                }}
            />

            {/* Zona de contenido */}
            <Box
                sx={{
                    height: "52%",
                    display: "flex",
                    flexDirection: "column",
                    px: 1,
                    pt: 2,
                    pb: 1,
                    minHeight: 0,
                }}
            >
                <Box sx={{ width: '100%' }}>
                    <Typography
                        variant="h6"
                        sx={{
                            mb: 1.2,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', mb:2 }}>
                    <Box sx={{ width: '80%' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                opacity: 0.95,
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                            }}
                        >
                            {description || ""}
                        </Typography>
                    </Box>

                    <Box sx={{ width: '20%' }}>
                        <Box
                            sx={{
                                mt: "auto",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                                pt: 1,
                            }}
                        >
                            <IconButton
                                disableRipple
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openInfo();
                                }}
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    background: isHovered ? "#000" : isDark ? "#000" : "#20BC71",
                                    border: `2px solid ${isHovered ? "#000" : isDark ? "#000" : "#20BC71"}`,
                                    color: isHovered ? "#fff" : isDark ? "#fff" : "#1A1A1A",
                                    transition: "all 260ms ease",
                                    flexShrink: 0,
                                }}
                            >
                                <ExpandMoreIcon
                                    sx={{
                                        fontSize: 26,
                                        transition: "transform 260ms ease",
                                        transform: isDark ? "rotate(180deg)" : "rotate(0deg)",
                                    }}
                                />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}